import { useCallback, useState } from "react";
import { useFormik } from "formik";
import {
  CreateDynamicSchema,
  RequiredField,
  ConditionalField,
  OPTION_MSG,
  EmailRegex,
  REQUIRED_MSG,
  SELECT_MSG,
} from "../schema/formik";
import { MisdeliveryFormData } from "../models/misDelivery";


export const msdInitialForm: MisdeliveryFormData = {
  type: "MSD",
  reportingTerminal: "",
  hasProNumber: undefined,
  proNumber: undefined,
  originTerminal: "",
  destinationTerminal: "",
  pickupTerminal: "",
  lastConfirmedManifest: undefined,
  misdeliveryContactName: "",
  misdeliveryAddress1: "",
  misdeliveryAddress2: "",
  misdeliveryCity: "",
  misdeliveryState: "",
  misdeliveryZip: "",
  misdeliveryContactPhone:undefined,
  misdeliveryContactEmail: "",
  callerName: "",
  callerPhone: undefined,
  callerExt: undefined,
  callerEmail: "",
  currentLocationAddress1: "",
  currentLocationAddress2: "",
  currentLocationCity: "",
  currentLocationState: "",
  currentLocationZip: "",
  currentContactName: "",
  currentContactPhone: undefined,
  currentContactExt: undefined,
  currentContactEmail: "",
  shipmentDeliveredOutsideUS: "",
  currentLocationDifferentThanMsdPoint: "",
  hasMisdeliveredPalletPro: undefined,
  misdeliveredPalletPro: undefined,
  palletShipperName: "",
  palletConsigneeName: "",
  totalPiecesMisdelivered: undefined,
  shrinkWrappedPallets: undefined,
  productMixedWithPallet: undefined,
  looseWithShipment: undefined,
  commodityCode: "",
  packageType: "",
  commodityDescription: "",
  isMisdeliveryHazmat: undefined,
  unNumber: "",
  canProvidePhotos: undefined,
  freightLabel: "",
  msdDescription: "",
  pickupWillLeaveShort: undefined,
  shortageDescription: "",
  confirmPalletCountAtInitialDelivery: undefined,
  otherInformation: "",
  callTakenBy: "",
  // f18ProNumber: "",
  // additionalNotes: "",
};

const validationConfig = [
  RequiredField("type", "", false),
  RequiredField("reportingTerminal", "", false),
  RequiredField("hasProNumber", OPTION_MSG),
  ConditionalField("proNumber", "hasProNumber", "Y", true, REQUIRED_MSG, "number", false, 11, "PRO Number must be 11 digits or less", true, "misdeliveredPalletPro", "The misdelivered shipment PRO number cannot be the same as the misdelivered pallet PRO number"),
  RequiredField("originTerminal", "", false),
  ConditionalField("destinationTerminal", "hasProNumber"),
  RequiredField("pickupTerminal"),
  RequiredField("lastConfirmedManifest", "", false),
  ConditionalField("misdeliveryContactName", "hasProNumber", "N", true, REQUIRED_MSG, "string", false, 30, "Contact name must be 30 characters or less"),
  ConditionalField("misdeliveryAddress1", "hasProNumber", "N", true, REQUIRED_MSG, "string", false, 30, "Address 1 must be 30 characters or less"),
  RequiredField("misdeliveryAddress2", "", false, "string", false, 30, "Address 2 must be 30 characters or less"),
  ConditionalField("misdeliveryCity", "hasProNumber", "N", true, REQUIRED_MSG, "string", false, 20, "City must be 20 characters or less"),
  ConditionalField("misdeliveryState", "hasProNumber","N"),
  ConditionalField("misdeliveryZip", "hasProNumber", "N", true, REQUIRED_MSG, "string", false, 6, "Zip code must be 6 digits or less"),
  RequiredField("misdeliveryContactPhone", REQUIRED_MSG, true, "number", false, 10, "misdelivery contact number must be 10 digits or less"),
  {
    name: "misdeliveryContactEmail",
    type: "string",
    required: true,
    message: REQUIRED_MSG,
    matches: EmailRegex,
    matchesMessage: "Invalid Email Address",
    max: 40,
    maxMessage: "Email address must be 40 characters or less"
  },
  RequiredField("callerName", REQUIRED_MSG, true, "string", false, 30, "Name must be 30 characters or less"),
  RequiredField("callerPhone", "", false, "number", false, 10, "Phone # must be 10 digits or less"),
  RequiredField("callerExt", "", false, "number", false, 6, "Ext must be 6 digits or less"),
  {
    name: "callerEmail",
    type: "string",
    matches: EmailRegex,
    matchesMessage: "Invalid Email Address",
    max: 40,
    maxMessage: "Email address must be 40 characters or less"
  },
  { name: "currentContactPhone", type: "number", max: 30, maxMessage: "Phone # must be 30 digits or less" },
  { name: "currentContactExt", type: "number", max: 6, maxMessage: "Ext must be 6 digits or less" },
  { name: "currentContactEmail", type: "string", matches: EmailRegex, matchesMessage: "Invalid Email Address", max: 40, maxMessage: "Email address must be 40 characters or less" },
  RequiredField("shipmentDeliveredOutsideUS", OPTION_MSG),

  ConditionalField("currentLocationDifferentThanMsdPoint", "hasProNumber", "Y", true, OPTION_MSG),
  ConditionalField("currentContactName", "hasProNumber", "Y", true, REQUIRED_MSG, "string", false, 30, "Name must be 30 characters or less"),
  ConditionalField("currentLocationAddress1", "hasProNumber", "Y", true, REQUIRED_MSG, "string", false, 30, "Address 1  must be 30 characters or less"),
  RequiredField("currentLocationAddress2", "", false, "string", false, 30, "Address 2 must be 30 characters or less"),
  ConditionalField("currentLocationCity", "hasProNumber"),
  ConditionalField("currentLocationZip", "hasProNumber"),
  ConditionalField("currentLocationState", "hasProNumber"),
  RequiredField("hasMisdeliveredPalletPro", OPTION_MSG),
  ConditionalField("misdeliveredPalletPro", "hasMisdeliveredPalletPro", "Y", true,  REQUIRED_MSG, "number", false, 11, "PRO # must be 11 digits or less", true, "proNumber", "The misdelivered pallet PRO number cannot be the same as the misdelivered shipment PRO number"),
  { name: "palletShipperName", type: "string"},
  { name: "palletConsigneeName", type: "string"},
  { name: "shipperName", type: "string", max: 30, maxMessage: "Shipper name must be 30 characters or less" },
  { name: "consigneeName", type: "string", max: 30, maxMessage: "Consignee name must be 30 characters or less" },
  RequiredField("totalPiecesMisdelivered",  REQUIRED_MSG, true, "number", false, 5, "Total pieces must be 5 digits or less"),
  RequiredField("shrinkWrappedPallets", REQUIRED_MSG, true, "string", false, 2, "Shrink wrapped pallets must be 2 digits or less"),
  RequiredField("productMixedWithPallet", OPTION_MSG),
  RequiredField("looseWithShipment",OPTION_MSG),
  RequiredField("commodityCode", SELECT_MSG, true, "string", false, 6, "Commodity code must be 6 characters or less"),
  RequiredField("packageType", SELECT_MSG, true, "string", false, 2, "Package type must be 2 characters or less"),
  RequiredField("commodityDescription", REQUIRED_MSG, true, "string", false, 100, "Commodity description must be 100 characters or less"),
  RequiredField("isMisdeliveryHazmat", OPTION_MSG),
  ConditionalField("unNumber", "isMisdeliveryHazmat"),
  RequiredField("canProvidePhotos", OPTION_MSG),
  RequiredField("freightLabel", REQUIRED_MSG, true, "string", false, 180, "Freight label must be 180 characters or less"),
  RequiredField("msdDescription", REQUIRED_MSG, true, "string", false, 180, "Misdelivery description must be 180 characters or less"),
  RequiredField("pickupWillLeaveShort", OPTION_MSG),
  ConditionalField("shortageDescription", "pickupWillLeaveShort", "Y", true, REQUIRED_MSG, "string", false, 180, "Shortage description must be 180 characters or less"),
  // ConditionalField("confirmPalletCountAtInitialDelivery", "pickupWillLeaveShort", "N", true, "Confirm pallet count is required.", "string", false, 2, "Pallet count must be 2 digits or less"),
  RequiredField("confirmPalletCountAtInitialDelivery", REQUIRED_MSG, true, "number", false, 2, "Misdelivery description must be 2 digits or less" ),
  RequiredField("otherInformation", "", false, "string", false, 1000, "Other information must be 1000 characters or less"),
  RequiredField("callTakenBy", REQUIRED_MSG, true, "string", false, 40, "Call taken by must be 40 characters or less"),
  // RequiredField("f18ProNumber", "PRO # Number is required.", false, "number", false, 11, "PRO # must be 11 digits or less"),
  // RequiredField("additionalNotes", "Additional notes are required", false, "string"),
];

// Get the group-level schema for 'at least one required'

// Combine field-level and group-level schemas
const validationSchema =
  CreateDynamicSchema(validationConfig);

export const useMisdeliveryForm = (
  initialData?: Partial<MisdeliveryFormData>,
) => {
  // Local touched state to ensure proper re-rendering
  const [localTouched, setLocalTouched] = useState<
    Partial<Record<keyof MisdeliveryFormData, boolean>>
  >({});

  // Initialize Formik with Yup validation
  const formik = useFormik<MisdeliveryFormData>({
    initialValues: {
      ...msdInitialForm,
      ...initialData,
    },
    validationSchema,
    validateOnChange: true,
    validateOnBlur: true,
    onSubmit: (_values) => {
    },
  });

  const setFieldTouched = useCallback(
    (
      field: keyof MisdeliveryFormData,
      touched: boolean,
      shouldValidate?: boolean,
    ) => {
      setLocalTouched((prev) => {
        const next = { ...prev };
        // Important: set explicit boolean so we can override Formik's touched
        // immediately (Formik updates are async). Using `false` ensures
        // `touched[field] && errors[field]` becomes falsy right away.
        next[field] = touched;
        return next;
      });

      return formik.setFieldTouched(field, touched, shouldValidate);
    },
    [formik],
  );

  // Backward compatible methods that use Formik internally
  const updateField = useCallback(
    (field: keyof MisdeliveryFormData, value: string | number | undefined) => {
      formik.setFieldValue(field, value);
      // Validate the field if it was previously touched
      if (formik.touched[field]) {
        formik.validateField(field);
      }
    },
    [formik]
  );

  const updateMultipleFields = useCallback(
    (updates: Partial<MisdeliveryFormData>) => {
      Object.entries(updates).forEach(([key, value]) => {
        formik.setFieldValue(key, value);
      });
    },
    [formik]
  );

  // Enhanced onBlur handler that marks field as touched and validates
  const handleFieldBlur = useCallback(
    (field: keyof MisdeliveryFormData) => {
      // Update touched state (both local + Formik)
      void (async () => {
        try {
          await setFieldTouched(field, true, false);

          // Then validate separately
          await formik.validateField(field);
        } catch (error) {
          console.error(
            `❌ Error updating touched/validation for ${field}:`,
            error
          );
        }
      })();
    },
    [formik, setFieldTouched]
  );

  const resetForm = useCallback(() => {
    formik.resetForm({
      values: {
        ...msdInitialForm,
        ...initialData,
      },
    });
    setLocalTouched({});
  }, [formik, initialData]);

  // Enhanced validation using Yup schema
  const validateField = useCallback(
    async (
      field: keyof MisdeliveryFormData,
      value: string
    ): Promise<string | undefined> => {
      try {
        await validationSchema.validateAt(field, {
          ...formik.values,
          [field]: value,
        });
        return undefined;
      } catch (error: any) {
        return error.message;
      }
    },
    [formik.values]
  );

  const validateForm = useCallback(async (): Promise<boolean> => {
    // Run validation and get all errors
    const errors = await formik.validateForm();

    // Mark ALL fields as touched so error messages will display
    const allFieldsTouched = Object.keys(formik.values).reduce(
      (touched, field) => {
        touched[field as keyof MisdeliveryFormData] = true;
        return touched;
      },
      {} as Record<keyof MisdeliveryFormData, boolean>
    );

    formik.setTouched(allFieldsTouched);
    setLocalTouched(allFieldsTouched);

    // If there are errors, also set them explicitly to ensure they show
    if (Object.keys(errors).length > 0) {
      formik.setErrors(errors);
      return false;
    }

    return true;
  }, [formik]);

  // Custom setErrors method for backward compatibility
  const setErrors = useCallback(
    (errors: Partial<Record<keyof MisdeliveryFormData, string>>) => {
      formik.setErrors(errors);
    },
    [formik]
  );

  return {
    // Original interface
    formData: formik.values,
    errors: formik.errors,
    updateField,
    updateMultipleFields,
    resetForm,
    validateForm,
    validateField,
    setErrors,
    handleFieldBlur,

    // Additional Formik methods for enhanced functionality
    formik,
    isValid: formik.isValid,
    isSubmitting: formik.isSubmitting,
    touched: { ...formik.touched, ...localTouched },
    handleChange: formik.handleChange,
    handleBlur: formik.handleBlur,
    handleSubmit: formik.handleSubmit,
    setFieldTouched,
    setFieldValue: formik.setFieldValue,

    // Enhanced handlers that combine custom logic with Formik
    getFieldProps: formik.getFieldProps,
    getFieldMeta: formik.getFieldMeta,
  };
};
